import React, { useRef, useEffect } from "react";
import { Animated, Easing, ImageBackground } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../../components/style/Style";

interface BackgroundProps {
    complete: boolean;
    imageUri: string;
    opacity: Animated.Value;
}

export const AnimatedBackground: React.FC<BackgroundProps> = ({ complete, imageUri, opacity }) => {
    const screenHeight = 660;
    const height = useRef(new Animated.Value(0)).current;
    const styles = useDynamicStyles(calculateStyles);

    useEffect(() => {
        Animated.timing(height, {
            toValue: screenHeight,
            useNativeDriver: true,
            duration: 500,
            easing: Easing.inOut(Easing.quad),
        }).start();
    }, [height, screenHeight]);

    return (
        <Animated.View style={[styles.exitBlock, { height, opacity }]}>
            <ImageBackground source={{ uri: imageUri }} style={[styles.background]} />
        </Animated.View>
    );
};

const calculateStyles = () => {
    return EStyleSheet.create({
        exitBlock: {
            alignSelf: "stretch",
            height: 0,
            position: "absolute",
            left: 0,
            right: 0,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.SPLASH_BACKGROUND),
        },
        background: {
            width: "100%",
            height: "100%",
        },
    });
};
